module.exports = __webpack_public_path__ + "img/zap.e7f80a0e.svg";